import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// Translation files
import translationENCommon from 'src/shared/locales/en/common.json';
import fundraiserTranslationEN from 'src/shared/locales/en/fundraiser.json';
import invoiceTranslationEN from 'src/shared/locales/en/invoice.json';
import memberTranslationEN from 'src/shared/locales/en/member.json';
import fileTranslationEN from 'src/shared/locales/en/file.json';
import groupMessageTranslationEN from 'src/shared/locales/en/groupMessage.json';
import giftTranslationEN from 'src/shared/locales/en/gift.json';
import dashboardTranslationEN from 'src/shared/locales/en/dashboard.json';
import userTranslationEN from 'src/shared/locales/en/user.json';
import districtTranslationEN from 'src/shared/locales/en/district.json';
import associationTranslationEN from 'src/shared/locales/en/association.json';
import eventTranslationEN from 'src/shared/locales/en/event.json';
import installCustomerTranslationEN from 'src/shared/locales/en/installCustomer.json';
import webformsTranslationEN from 'src/shared/locales/en/webforms.json';
import onboardingTranslationEN from 'src/shared/locales/en/onboarding.json';
import statisticsTranslationEN from 'src/shared/locales/en/statistics.json';
import organizationTranslationEN from 'src/shared/locales/en/organization.json';
import memberProfileTranslationEN from 'src/shared/locales/en/memberProfile.json';
import customerTranslationEN from 'src/shared/locales/en/customer.json';
import documentArchiveTranslationEN from 'src/shared/locales/en/documentArchive.json';
import settingsTranslationEN from 'src/shared/locales/en/settings.json';
import troubleshootingTranslationEN from 'src/shared/locales/en/troubleshooting.json';
import helpTranslationEN from 'src/shared/locales/en/help.json';
import helpArticlesTranslationEN from 'src/shared/locales/en/helpArticles.json';

// Swedish translations
import translationSECommon from 'src/shared/locales/sv/common.json';
import fundraiserTranslationSE from 'src/shared/locales/sv/fundraiser.json';
import invoiceTranslationSE from 'src/shared/locales/sv/invoice.json';
import memberTranslationSE from 'src/shared/locales/sv/member.json';
import fileTranslationSV from 'src/shared/locales/sv/file.json';
import groupMessageTranslationSE from 'src/shared/locales/sv/groupMessage.json';
import giftTranslationSE from 'src/shared/locales/sv/gift.json';
import dashboardTranslationSE from 'src/shared/locales/sv/dashboard.json';
import userTranslationSE from 'src/shared/locales/sv/user.json';
import districtTranslationSE from 'src/shared/locales/sv/district.json';
import associationTranslationSE from 'src/shared/locales/sv/association.json';
import eventTranslationSE from 'src/shared/locales/sv/event.json';
import installCustomerTranslationSE from 'src/shared/locales/sv/installCustomer.json';
import webformsTranslationSE from 'src/shared/locales/sv/webforms.json';
import onboardingTranslationSE from 'src/shared/locales/sv/onboarding.json';
import statisticsTranslationSE from 'src/shared/locales/sv/statistics.json';
import organizationTranslationSE from 'src/shared/locales/sv/organization.json';
import memberProfileTranslationSE from 'src/shared/locales/sv/memberProfile.json';
import customerTranslationSE from 'src/shared/locales/sv/customer.json';
import documentArchiveTranslationSE from 'src/shared/locales/sv/documentArchive.json';
import settingsTranslationSE from 'src/shared/locales/sv/settings.json';
import troubleshootingTranslationSE from 'src/shared/locales/sv/troubleshooting.json';
import helpTranslationSE from 'src/shared/locales/sv/help.json';
import helpArticlesTranslationSE from 'src/shared/locales/sv/helpArticles.json';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {
    common: translationENCommon,
    member: memberTranslationEN,
    fundraiser: fundraiserTranslationEN,
    groupMessage: groupMessageTranslationEN,
    file: fileTranslationEN,
    gift: giftTranslationEN,
    invoice: invoiceTranslationEN,
    dashboard: dashboardTranslationEN,
    user: userTranslationEN,
    district: districtTranslationEN,
    association: associationTranslationEN,
    event: eventTranslationEN,
    installCustomer: installCustomerTranslationEN,
    webforms: webformsTranslationEN,
    onboarding: onboardingTranslationEN,
    statistics: statisticsTranslationEN,
    organization: organizationTranslationEN,
    memberProfile: memberProfileTranslationEN,
    customer: customerTranslationEN,
    documentArchive: documentArchiveTranslationEN,
    settings: settingsTranslationEN,
    troubleshooting: troubleshootingTranslationEN,
    help: helpTranslationEN,
    helpArticles: helpArticlesTranslationEN,
  },
  sv: {
    common: translationSECommon,
    member: memberTranslationSE,
    fundraiser: fundraiserTranslationSE,
    groupMessage: groupMessageTranslationSE,
    file: fileTranslationSV,
    gift: giftTranslationSE,
    invoice: invoiceTranslationSE,
    dashboard: dashboardTranslationSE,
    user: userTranslationSE,
    district: districtTranslationSE,
    association: associationTranslationSE,
    event: eventTranslationSE,
    installCustomer: installCustomerTranslationSE,
    webforms: webformsTranslationSE,
    onboarding: onboardingTranslationSE,
    statistics: statisticsTranslationSE,
    organization: organizationTranslationSE,
    memberProfile: memberProfileTranslationSE,
    customer: customerTranslationSE,
    documentArchive: documentArchiveTranslationSE,
    settings: settingsTranslationSE,
    troubleshooting: troubleshootingTranslationSE,
    help: helpTranslationSE,
    helpArticles: helpArticlesTranslationSE,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'sv',
    ns: [
      'common',
      'dashboard',
      'member',
      'fundraiser',
      'groupMessage',
      'file',
      'gift',
      'user',
      'event',
      'installCustomer',
      'webforms',
      'statistics',
      'organization',
      'memberProfile',
      'customer',
      'documentArchive',
      'settings',
      'troubleshooting',
      'help',
      'helpArticles',
    ], // Add new ones here
    defaultNS: 'common', // The NS that is always loaded
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    compatibilityJSON: 'v3', // Plural-stöd med _plural
  });

export default i18n;
